export function clean(value) {
  return String(value || "").trim();
}

export function tsMillis(value) {
  if (!value) return 0;
  if (typeof value?.toMillis === "function") return value.toMillis();
  if (typeof value?.seconds === "number") return value.seconds * 1000;
  return 0;
}

export function formatClock(value) {
  const ms = tsMillis(value);
  if (!ms) return "—";
  return new Date(ms).toLocaleTimeString([], {
    hour: "numeric",
    minute: "2-digit",
  });
}

export function formatQueueElapsed(value, nowMs) {
  const start = tsMillis(value);
  if (!start) return "0:00";
  const diffSec = Math.max(0, Math.floor((nowMs - start) / 1000));
  const min = Math.floor(diffSec / 60);
  const sec = diffSec % 60;
  return `${min}:${String(sec).padStart(2, "0")}`;
}

export function prettyCallType(callType) {
  return callType === "courtesyTransport" ? "Courtesy" : "Emergency";
}

export function prettyUnitStatus(status) {
  switch (status) {
    case "DISP":
      return "Disp";
    case "ON_SCENE":
      return "On Scene";
    case "TO_HQ":
      return "To HQ";
    case "ARRIVED_HQ":
      return "Arrived HQ";
    case "TRANSPORTING":
      return "Transporting";
    case "ARRIVED":
      return "Arrived";
    case "CLEAR":
      return "Clear";
    case "AVAIL":
      return "Avail";
    case "OOS":
      return "OOS";
    default:
      return status || "—";
  }
}